<template>
    <div>
        <Header />
        <section class="section-b-space">
            <div>
                <component-header
                    :title="`${
                        partnerAllData && partnerAllData.authentication
                            ? partnerAllData.authentication.userName
                            : ''
                    } - Payment Info`"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasback="true"
                    createButtonText="Create Payment"
                    @back-press="$router.push('./basic-info')"
                    @create-press="openMakePayment"
                />
                <b-modal
                    v-model="isShowPaymentModel"
                    title="Create Payment"
                    header-class="header-nipige-class make-payment"
                    :header-bg-variant="'primary'"
                    :header-text-variant="'light'"
                    size="md"
                    centered
                    hide-footer
                    no-close-on-esc
                    no-close-on-backdrop
                >
                    <b-row>
                        <b-col class="ml-1">
                            <eb-select
                                type="select"
                                v-model="selectedPaymentType"
                                :options="paymentTypeList"
                                label="label"
                                placeholder="Select Payment Type *"
                                cssClass="ml-1 input-width-change"
                                :id="'selectPaymentType'"
                            ></eb-select>
                        </b-col>
                        <b-col class="ml-n3 mr-1">
                            <c-input
                                inputType="number"
                                inputId="Amount"
                                labelText="Amount *"
                                v-model="amountValue"
                                class="border-style-input"
                            />
                        </b-col>
                    </b-row>
                    <div class="ml-1 mr-1">
                        <label>Payment Date *</label>
                        <b-input
                            id="payment-date"
                            type="date"
                            v-model="paymentDate"
                        ></b-input>
                    </div>
                    <c-input
                        v-if="selectedPaymentType.value == 'CASH'"
                        inputType="text"
                        inputId="ReceiptNo"
                        labelText="Receipt No"
                        v-model="receiptNo"
                        class="mt-3 ml-1 mr-1 border-style-input"
                    />

                    <div v-if="selectedPaymentType.value == 'CHEQUE'">
                        <b-row class="mt-n1">
                            <b-col class="mr-n2">
                                <c-input
                                    inputType="text"
                                    inputId="bankName"
                                    labelText="Bank Name"
                                    v-model="bankName"
                                    class="mt-2 ml-1 mr-1 border-style-input"
                                />
                            </b-col>
                            <b-col class="ml-n3">
                                <c-input
                                    inputType="text"
                                    inputId="accountNumber"
                                    labelText="Account Number"
                                    v-model="accountNumber"
                                    class="mt-2 ml-1 mr-1 border-style-input"
                                />
                            </b-col>
                        </b-row>

                        <c-input
                            inputType="text"
                            inputId="ifscNo"
                            labelText="IFSC Number"
                            v-model="ifscNo"
                            class="mt-3 ml-1 mr-1 border-style-input"
                        />
                        <c-input
                            inputType="text"
                            inputId="fullName"
                            labelText="Full name"
                            v-model="fullName"
                            class="mt-3 ml-1 mr-1 border-style-input"
                        />
                        <c-input
                            inputType="text"
                            inputId="chequeNo"
                            labelText="Cheque Number"
                            v-model="chequeNo"
                            class="mt-3 ml-1 mr-1 border-style-input"
                        />
                        <b-row class="date-style">
                            <b-col class="ml-1">
                                <label>Issue Date</label>
                                <b-input
                                    id="issue-date"
                                    type="date"
                                    class="input-width-change"
                                    v-model="issueDate"
                                ></b-input>
                            </b-col>
                            <b-col class="ml-n3">
                                <label>Deposite Date</label>
                                <b-input
                                    id="payment-date"
                                    type="date"
                                    class="input-width-change"
                                    v-model="depositeDate"
                                ></b-input>
                            </b-col>
                        </b-row>
                    </div>
                    <c-input
                        inputType="text"
                        inputId="comments"
                        labelText="Comments"
                        v-model="comments"
                        class="mt-3 ml-1 mr-1 border-style-input"
                    />
                    <div class="text-center mt-3 mb-3">
                        <button
                            type="button"
                            class="btn btn-primary"
                            classic="mr-1 btn-primary"
                            text="Save"
                            @click="initiatePayment"
                        >
                            Proceed
                        </button>
                    </div>
                </b-modal>
                <div class="nipige-v-card-class-top">
                    <div class="text-center mt-5" v-if="isLoading">
                        Loading.............
                    </div>
                    <b-row v-if="!isLoading" class="pl-1 pr-1">
                        <b-col md="3">
                            <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card
                                    height="200"
                                    :elevation="hover ? 10 : 0"
                                    style="
                                        box-shadow: 0px 0px 12px
                                            rgba(0, 0, 0, 0.1);
                                    "
                                    :class="{
                                        'on-hover': hover,
                                        'nipige-v-card-class-top-allowed':
                                            'nipige-v-card-class-top-allowed',
                                    }"
                                >
                                    <div class="allowed-payment-card">
                                        <h4 class="allowed-payment-title">
                                            Allowed Payment
                                        </h4>
                                        <div class="allowed-payment-list">
                                            <div class="allowed-payment-row">
                                                <span
                                                    class="my-payment-info-class allowed-payment-label"
                                                >
                                                    COD
                                                </span>
                                                <span class="allowed-payment-colon"
                                                    >:</span
                                                >
                                                <v-switch
                                                    class="allowed-payment-switch"
                                                    color="indigo"
                                                    inset
                                                    dense
                                                    hide-details
                                                    @change="updateCodOrOnline"
                                                    v-model="codEnable"
                                                >
                                                </v-switch>
                                            </div>
                                            <div class="allowed-payment-row">
                                                <span
                                                    class="my-payment-info-class allowed-payment-label"
                                                >
                                                    Online
                                                </span>
                                                <span class="allowed-payment-colon"
                                                    >:</span
                                                >
                                                <v-switch
                                                    class="allowed-payment-switch"
                                                    color="indigo"
                                                    inset
                                                    dense
                                                    hide-details
                                                    @change="updateCodOrOnline"
                                                    v-model="onlineEnable"
                                                >
                                                </v-switch>
                                            </div>
                                        </div>
                                    </div>
                                </v-card>
                            </v-hover>
                        </b-col>
                        <b-col md="9">
                            <b-row>
                                <v-hover v-slot="{ hover }" close-delay="170">
                                    <v-card
                                        :elevation="hover ? 10 : 0"
                                        style="
                                            box-shadow: 0px 0px 12px
                                                rgba(0, 0, 0, 0.1);
                                        "
                                        :class="{
                                            'on-hover': hover,
                                            'nipige-v-card-class-top-allowed mr-2':
                                                'nipige-v-card-class-top-allowed mr-2',
                                        }"
                                    >
                                        <div
                                            v-if="
                                                !checkSellerOrOther &&
                                                onlineEnable
                                            "
                                            class="mt-2"
                                        >
                                            <h4
                                                class="text-center online-pay-method-class"
                                            >
                                                Online Payment Details
                                            </h4>
                                        </div>
                                        <b-row
                                            v-if="
                                                !checkSellerOrOther &&
                                                onlineEnable
                                            "
                                        >
                                            <b-modal
                                                title="Update Paytm Details"
                                                header-class="header-nipige-class"
                                                id="modal-center"
                                                ref="modal-paytm"
                                                centered
                                                hide-footer
                                                
                                            >
                                                <c-input
                                                    inputType="text"
                                                    inputId="paymentInfo"
                                                    labelText="Enter Paytm Id"
                                                    v-model="paytmId"
                                                    class="mt-3 ml-1 mr-1 border-style-input"
                                                />
                                                <c-input
                                                    inputType="text"
                                                    inputId="paymentInfo"
                                                    labelText="Enter Paytm Secret Key"
                                                    v-model="paytmKey"
                                                    class="mt-3 ml-1 mr-1 border-style-input"
                                                />
                                                <div class="text-center mt-3">
                                                    <button
                                                        type="button"
                                                        class="btn btn-primary"
                                                        classic="mr-1 btn-primary"
                                                        text="Save"
                                                        @click="
                                                            submitPaytmDetails(
                                                                'paytm',
                                                            )
                                                        "
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </b-modal>
                                            <b-col>
                                                <div
                                                    v-if="
                                                        paytmKey == '' ||
                                                        paytmId == ''
                                                    "
                                                    class="text-center mt-4"
                                                >
                                                    <b-button
                                                        class="main-navigation-button w-1"
                                                        variant="white"
                                                        btn-color="primary1"
                                                        @click="
                                                            editPaytmDetails(
                                                                'paytm',
                                                            )
                                                        "
                                                    >
                                                        <v-avatar
                                                            class="ml-n2 mt-n1"
                                                            size="35"
                                                        >
                                                            <img
                                                                src="img/Add.png"
                                                            /> </v-avatar
                                                    ></b-button>
                                                    <h4>Add Paytm</h4>
                                                </div>
                                                <v-hover
                                                    v-if="
                                                        paytmKey != '' &&
                                                        paytmId != ''
                                                    "
                                                    v-slot="{ hover }"
                                                    close-delay="170"
                                                >
                                                    <v-card
                                                        height="160"
                                                        :elevation="
                                                            hover ? 16 : 2
                                                        "
                                                        :class="{
                                                            'on-hover': hover,
                                                            'nipige-v-card-class shadow-none':
                                                                'nipige-v-card-class shadow-none',
                                                        }"
                                                    >
                                                        <b-row
                                                            class="pl-3 pt-1"
                                                        >
                                                            <b-col md="5">
                                                                <img
                                                                    class="ml-1"
                                                                    style="
                                                                        height: 60px;
                                                                        width: 80px;
                                                                    "
                                                                    src="img/paytm.jpeg"
                                                                    alt=""
                                                                />
                                                            </b-col>
                                                            <b-col md="7">
                                                                <div
                                                                    class="float-right mt-2 mr-3"
                                                                >
                                                                    <b-button
                                                                        class="main-navigation-button w-1"
                                                                        variant="white"
                                                                        btn-color="primary1"
                                                                        @click="
                                                                            editPaytmDetails(
                                                                                'paytm',
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-avatar
                                                                            class="ml-n2 mt-n1"
                                                                            size="35"
                                                                        >
                                                                            <img
                                                                                src="img/Edit.png"
                                                                            /> </v-avatar
                                                                    ></b-button>
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row
                                                            class="pl-4 mt-n3"
                                                        >
                                                            <b-col>
                                                                <h4>
                                                                    Id :
                                                                    <strong
                                                                        class="ac-details-class"
                                                                    >
                                                                        {{
                                                                            paytmId.length >
                                                                            30
                                                                                ? paytmId.slice(
                                                                                      0,
                                                                                      25,
                                                                                  ) +
                                                                                  "......"
                                                                                : paytmId
                                                                        }}
                                                                    </strong>
                                                                </h4>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row
                                                            class="pl-4 mt-n4"
                                                        >
                                                            <b-col>
                                                                <h4>
                                                                    Key :
                                                                    <strong
                                                                        class="ac-details-class"
                                                                    >
                                                                        {{
                                                                            paytmKey.length >
                                                                            30
                                                                                ? paytmKey.slice(
                                                                                      0,
                                                                                      25,
                                                                                  ) +
                                                                                  "......"
                                                                                : paytmKey
                                                                        }}
                                                                    </strong>
                                                                </h4>
                                                            </b-col>
                                                        </b-row>
                                                    </v-card>
                                                </v-hover>
                                            </b-col>

                                            <b-col>
                                                <b-modal
                                                    title="Update Cashfree Details"
                                                    header-class="header-nipige-class"
                                                    id="modal-center"
                                                    ref="modal-cashfree"
                                                    size="md"
                                                    centered
                                                    hide-footer
                                                >
                                                    <c-input
                                                        inputType="text"
                                                        inputId="paymentInfo"
                                                        labelText="Enter Cashfree Id"
                                                        v-model="cashfreeId"
                                                        class="mt-3 ml-1 mr-1 border-style-input"
                                                    />
                                                    <c-input
                                                        inputType="text"
                                                        inputId="paymentInfo"
                                                        labelText="Enter Cashfree Secret Key"
                                                        v-model="cashfreeKey"
                                                        class="mt-3 ml-1 mr-1 border-style-input"
                                                    />
                                                    <div
                                                        class="text-center mt-3"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="btn btn-primary"
                                                            classic="mr-1 btn-primary"
                                                            text="Save"
                                                            @click="
                                                                submitPaytmDetails(
                                                                    'cashfree',
                                                                )
                                                            "
                                                        >
                                                            Save
                                                        </button>
                                                    </div>
                                                </b-modal>
                                                <div
                                                    v-if="
                                                        cashfreeKey == '' ||
                                                        cashfreeId == ''
                                                    "
                                                    class="text-center mt-4"
                                                >
                                                    <b-button
                                                        class="main-navigation-button w-1"
                                                        variant="white"
                                                        btn-color="primary1"
                                                        @click="
                                                            editPaytmDetails(
                                                                'cashfree',
                                                            )
                                                        "
                                                    >
                                                        <v-avatar
                                                            class="ml-n2 mt-n1"
                                                            size="35"
                                                        >
                                                            <img
                                                                src="img/Add.png"
                                                            /> </v-avatar
                                                    ></b-button>
                                                    <h4>Add Cashfree</h4>
                                                </div>
                                                <v-hover
                                                    v-if="
                                                        cashfreeKey != '' &&
                                                        cashfreeId != ''
                                                    "
                                                    v-slot="{ hover }"
                                                    close-delay="170"
                                                >
                                                    <v-card
                                                        height="160"
                                                        :elevation="
                                                            hover ? 10 : 0
                                                        "
                                                        :class="{
                                                            'on-hover': hover,
                                                            'nipige-v-card-class shadow-none':
                                                                'nipige-v-card-class shadow-none',
                                                        }"
                                                    >
                                                        <b-row
                                                            class="pl-4 pt-1"
                                                        >
                                                            <b-col md="5">
                                                                <img
                                                                    class="ml-1"
                                                                    style="
                                                                        height: 60px;
                                                                        width: 80px;
                                                                    "
                                                                    src="img/cashfree.jpg"
                                                                    alt=""
                                                                />
                                                            </b-col>
                                                            <b-col md="7">
                                                                <div
                                                                    class="float-right mt-2 mr-5"
                                                                >
                                                                    <b-button
                                                                        class="main-navigation-button w-1"
                                                                        variant="white"
                                                                        btn-color="primary1"
                                                                        @click="
                                                                            editPaytmDetails(
                                                                                'cashfree',
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-avatar
                                                                            class="ml-n2 mt-n1"
                                                                            size="35"
                                                                        >
                                                                            <img
                                                                                src="img/Edit.png"
                                                                            /> </v-avatar
                                                                    ></b-button>
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row
                                                            class="pl-4 mt-n3"
                                                        >
                                                            <b-col>
                                                                <h4>
                                                                    Id :
                                                                    <strong
                                                                        class="ac-details-class"
                                                                    >
                                                                        {{
                                                                            cashfreeId.length >
                                                                            30
                                                                                ? cashfreeId.slice(
                                                                                      0,
                                                                                      25,
                                                                                  ) +
                                                                                  "......"
                                                                                : cashfreeId
                                                                        }}</strong
                                                                    >
                                                                </h4>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row
                                                            class="pl-4 mt-n4"
                                                        >
                                                            <b-col>
                                                                <h4>
                                                                    Key :
                                                                    <strong
                                                                        class="ac-details-class"
                                                                    >
                                                                        {{
                                                                            cashfreeKey.length >
                                                                            30
                                                                                ? cashfreeKey.slice(
                                                                                      0,
                                                                                      25,
                                                                                  ) +
                                                                                  "......"
                                                                                : cashfreeKey
                                                                        }}</strong
                                                                    >
                                                                </h4>
                                                            </b-col>
                                                        </b-row>
                                                    </v-card>
                                                </v-hover>
                                            </b-col>
                                        </b-row>

                                        <b-row
                                            v-if="
                                                checkSellerOrOther &&
                                                onlineEnable
                                            "
                                        >
                                            <b-col>
                                                <b-row class="pl-3 pt-1">
                                                    <b-col md="8">
                                                        <div class="mt-2">
                                                            <h4
                                                                class="text-left online-pay-method-class"
                                                            >
                                                                Online Payment
                                                                Details
                                                            </h4>
                                                        </div></b-col
                                                    >
                                                    <b-col md="4">
                                                        <div
                                                            class="float-right mt-2 mr-3"
                                                        >
                                                            <b-button
                                                                class="main-navigation-button w-1"
                                                                variant="white"
                                                                btn-color="primary1"
                                                                @click="
                                                                    editPaytmDetails(
                                                                        'account',
                                                                    )
                                                                "
                                                            >
                                                                <v-avatar
                                                                    class="ml-n2 mt-n1"
                                                                    size="35"
                                                                >
                                                                    <img
                                                                        src="img/Edit.png"
                                                                    /> </v-avatar
                                                            ></b-button>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="pl-3 pt-1">
                                                    <b-col md="6">
                                                        <h5>
                                                            Acc Holder Name :
                                                            <strong
                                                                class="ac-details-class"
                                                                >{{
                                                                    sellerPayementDetails.accHolderName
                                                                }}</strong
                                                            >
                                                        </h5>
                                                    </b-col>
                                                    <b-col md="6">
                                                        <h5>
                                                            IFSC Code :
                                                            <strong
                                                                class="ac-details-class"
                                                                >{{
                                                                    sellerPayementDetails.ifscCode
                                                                }}</strong
                                                            >
                                                        </h5>
                                                    </b-col>
                                                    <b-col md="6">
                                                        <h5>
                                                            Bank Name :
                                                            <strong
                                                                class="ac-details-class"
                                                                >{{
                                                                    sellerPayementDetails.bankName
                                                                }}</strong
                                                            >
                                                        </h5>
                                                    </b-col>
                                                    <b-col md="6">
                                                        <h5>
                                                            Account Number :
                                                            <strong
                                                                class="ac-details-class"
                                                                >{{
                                                                    sellerPayementDetails.accNo
                                                                }}</strong
                                                            >
                                                        </h5>
                                                    </b-col>
                                                    <b-col md="6">
                                                        <h5>
                                                            Email :
                                                            <strong
                                                                class="ac-details-class"
                                                                >{{
                                                                    sellerPayementDetails.email
                                                                }}</strong
                                                            >
                                                        </h5>
                                                    </b-col>
                                                    <b-col md="6">
                                                        <h5>
                                                            Phone Number :
                                                            <strong
                                                                class="ac-details-class"
                                                                >{{
                                                                    sellerPayementDetails.phone
                                                                }}</strong
                                                            >
                                                        </h5>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="pl-3 pt-1">
                                                    <b-col class="vendor-class"
                                                        ><h6>
                                                            {{
                                                                sellerPayementDetails.vendorMode
                                                            }}
                                                            Vendor Id :
                                                            <strong
                                                                class="ac-details-class-vendor"
                                                                >{{
                                                                    sellerPayementDetails
                                                                        .venderId
                                                                        .length >
                                                                    10
                                                                        ? sellerPayementDetails.venderId.slice(
                                                                              0,
                                                                              10,
                                                                          ) +
                                                                          "...."
                                                                        : sellerPayementDetails.venderId
                                                                }}</strong
                                                            >
                                                        </h6></b-col
                                                    >
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </v-card>
                                </v-hover>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
                <b-modal
                    title="Update Bank Details"
                    header-class="header-nipige-class"
                    id="modal-center"
                    ref="modal-account"
                    size="md"
                    centered
                    hide-footer
                >
                    <ValidationObserver ref="observer">
                        <div class="input-wrapper">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Account holder name"
                            >
                                <c-input
                                    inputType="text"
                                    inputId="paymentInfo"
                                    labelText="Enter Account Holder Name"
                                    v-model="
                                        sellerPayementDetails.accHolderName
                                    "
                                    class="mt-3 ml-1 mr-1 border-style-input"
                                />
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="input-wrapper mt-4">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="IFSC code"
                            >
                                <c-input
                                    inputType="text"
                                    inputId="paymentInfo"
                                    labelText="Enter Ifsc Code"
                                    v-model="sellerPayementDetails.ifscCode"
                                    class="mt-3 ml-1 mr-1 border-style-input"
                                />
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="input-wrapper mt-4">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Bank name"
                            >
                                <c-input
                                    inputType="text"
                                    inputId="paymentInfo"
                                    labelText="Enter Bank Name"
                                    v-model="sellerPayementDetails.bankName"
                                    class="mt-3 ml-1 mr-1 border-style-input"
                                />
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="input-wrapper mt-4">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Account no."
                            >
                                <c-input
                                    inputType="number"
                                    inputId="paymentInfo"
                                    labelText="Enter Account No"
                                    v-model="sellerPayementDetails.accNo"
                                    class="mt-3 ml-1 mr-1 border-style-input"
                                />
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="input-wrapper mt-4">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Email"
                            >
                                <c-input
                                    inputType="text"
                                    inputId="paymentInfo"
                                    labelText="Enter Your Email"
                                    v-model="sellerPayementDetails.email"
                                    class="mt-3 ml-1 mr-1 border-style-input"
                                />
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="input-wrapper mt-4">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Phone no."
                            >
                                <c-tel-input
                                    :defaultInput="sellerPayementDetails.phone"
                                    v-model="sellerPayementDetails.phone"
                                    class="mt-3 ml-1 mr-1 border-style-input"
                                />
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="input-wrapper mt-4">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Vendor mode"
                            >
                                <eb-select
                                    type="select"
                                    v-model="
                                        sellerPayementDetails.vendorModeOptionSelect
                                    "
                                    :options="vendorModeOptions"
                                    label="label"
                                    :id="'selecttime'"
                                    :placeholder="'Select Vendor Mode'"
                                    :selected="
                                        sellerPayementDetails.vendorModeOptionSelect
                                    "
                                    class="ml-1 mr-1 mt-2"
                                ></eb-select>
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="input-wrapper mt-4">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Vendor id"
                            >
                                <c-input
                                    inputType="text"
                                    inputId="paymentInfo"
                                    labelText="Enter Vendor Id"
                                    v-model="sellerPayementDetails.venderId"
                                    class="ml-1 mr-1 border-style-input"
                                />
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="text-center mt-3">
                            <button
                                type="button"
                                class="btn btn-primary"
                                classic="mr-1 btn-primary"
                                text="Save"
                                @click="submitSellerPayment()"
                            >
                                Save
                            </button>
                        </div>
                    </ValidationObserver>
                </b-modal>
            </div>
        </section>
        <section class="mt-4">
            <component-header
                title="Transaction History"
                @search-query="(val) => (filter = val)"
                :isLoading="loading"
                @reload-data="getTransactionHistory"
                :hasback="false"
                :hasCreate="false"
            />
            <b-card class="card-wrap" border-variant="info">
                <b-row>
                    <b-col md="3" class="my-1">
                        <b-form-group label-cols-sm="3" class="mb-0">
                            <eb-select
                                type="select"
                                v-model="selectedPeriod"
                                :options="periodList"
                                label="text"
                                :id="'selecttime'"
                                :selected="selectedPeriod"
                                @input="changePeriod"
                            ></eb-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="table-responsive-sm">
                    <b-table
                        :fields="Columns"
                        :items="transactionList"
                        :dark="false"
                        :filter="filter"
                        :hover="true"
                        thead-class="header"
                        :striped="false"
                        :bordered="true"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :small="false"
                        show-empty
                        :fixed="false"
                    >
                        <template slot="cell(createdAt)" slot-scope="data">
                            <div>{{ data.item.createdAt | formatedate }}</div>
                        </template>
                        <template
                            slot="cell(paymentResponse.paymentMode)"
                            slot-scope="data"
                        >
                            <div>
                                {{
                                    data.item.paymentResponse.paymentMode
                                        | formatMode
                                }}
                            </div>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="transactionList.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                    ></b-pagination>
                </div>
            </b-card>
        </section>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
    ValidationProvider,
    ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import loader from "@/components/loader/nipigeloader.vue";
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import ComponentHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";

export default {
    components: {
        loader,
        cInput,
        cTelInput,
        ComponentHeader,
        ebSelect,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            isLoading: false,
            checkSellerOrOther: false,
            paytmId: "",
            paytmKey: "",
            cashfreeId: "",
            cashfreeKey: "",
            codEnable: false,
            onlineEnable: false,
            loading: false,
            paymentInfo: "",
            bankName: "",
            isShowPaymentModel: false,
            amountValue: "",
            comments: "",
            selectedPaymentType: "",
            accountNumber: "",
            paymentDate: "",
            receiptNo: "",
            issueDate: "",
            depositeDate: "",
            fullName: "",
            chequeNo: "",
            ifscNo: "",
            sellerPayementDetails: {
                accHolderName: "",
                ifscCode: "",
                bankName: "",
                accNo: "",
                email: "",
                phone: "",
                vendorModeOptionSelect: "",
                vendorMode: "",
                venderId: "",
            },
            vendorModeOptions: [
                {
                    label: "Paytm",
                    value: "PAYTM",
                },
                {
                    label: "Cashfree",
                    value: "CASHFREE",
                },
            ],
            paymentTypeList: [
                {
                    label: "Cash",
                    value: "CASH",
                },
                {
                    label: "Cheque",
                    value: "CHEQUE",
                },
            ],
            currentPage: 1,
            filter: "",
            perPage: 10,
            Columns: [
                {
                    key: "order",
                    label: "ID",
                    sortable: true,
                },
                {
                    key: "paymentService",
                    label: "Payment Service",
                },
                {
                    key: "paymentResponse.method",
                    label: "Payment Mode",
                },
                {
                    key: "amount.value",
                    label: "Amount",
                    sortable: true,
                },

                {
                    key: "paymentStatus",
                    label: "Payment Status",
                },
                {
                    key: "createdAt",
                    label: "Date",
                    sortable: true,
                },
            ],
            selectedPeriod: {
                text: "Last 7 days",
                value: 7,
            },
            periodList: [
                {
                    text: "Last 7 days",
                    value: 7,
                },
                {
                    text: "Last 15 days",
                    value: 15,
                },
                {
                    text: "Last 30 days",
                    value: 30,
                },
                {
                    text: "Last 3 Months",
                    value: 90,
                },
                {
                    text: "Last 6 Months",
                    value: 180,
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            partnerAllData: "partner/GetPartnerData",
            getPartnerPreferences: "partner/GetPartnerPreferences",
            transactionList: "subscription/GetTransactionsList",
            getPartnerPaymentPreferencesGetter:
                "partner/getPartnerPaymentPreferencesGetter",
            getPartnerPaymentConfig: "partner/GetPartnerPaymentConfig",
            getSellerProviderConfig: "partner/GetSellerProviderConfigGatter",
        }),
        paymentInfoData() {
            try {
                if (
                    this.getPartnerPreferences.paymentConfig &&
                    this.getPartnerPreferences.paymentConfig.UPIID
                ) {
                    return this.getPartnerPreferences.paymentConfig.UPIID;
                } else {
                    return "Not Available";
                }
            } catch (err) {
                return "Not Available";
            }
        },
    },
    watch: {
        isShowPaymentModel() {
            this.amountValue = "";
            this.comments = "";
            this.selectedPaymentType = "";
            this.accountNumber = "";
            this.paymentDate = "";
            this.receiptNo = "";
            this.issueDate = "";
            this.depositeDate = "";
            this.fullName = "";
            this.chequeNo = "";
            this.ifscNo = "";
            this.bankName = "";
        },
    },
    methods: {
        ...mapActions({
            updatePreference: "partner/updatePartnerPreferences",
            getPreferenceAction: "partner/getPartnerPreferences",
            getPartnerPaymentPreferencesAction:
                "partner/getPartnerPaymentPreferencesAction",
            getPartnerPaymentConfigAction:
                "partner/getPartnerPaymentConfigAction",
            getSellerProviderConfigAction:
                "partner/getSellerProviderConfigAction",
        }),
        async submitSellerPayment() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            let payloadAcountDetails = {
                id: this.partnerAllData._id,
                data: {
                    user: {
                        category: this.partnerAllData.category,
                    },
                    bank: {
                        name: this.sellerPayementDetails.bankName,
                        accountNo: this.sellerPayementDetails.accNo,
                        ifscCode: this.sellerPayementDetails.ifscCode,
                        accountName: this.sellerPayementDetails.accHolderName,
                        email: this.sellerPayementDetails.email,
                        phone: this.sellerPayementDetails.phone,
                    },
                },
            };

            if (
                this.sellerPayementDetails.vendorModeOptionSelect != "" &&
                this.sellerPayementDetails.vendorModeOptionSelect.value ==
                    "PAYTM"
            ) {
                payloadAcountDetails.data.paytm = {
                    vendorId: this.sellerPayementDetails.venderId,
                };
            }
            if (
                this.sellerPayementDetails.vendorModeOptionSelect != "" &&
                this.sellerPayementDetails.vendorModeOptionSelect.value ==
                    "CASHFREE"
            ) {
                payloadAcountDetails.data.cashfree = {
                    vendorId: this.sellerPayementDetails.venderId,
                };
            }

            await this.$store
                .dispatch(
                    "partner/updatePartnerPaymentConfigAction",
                    payloadAcountDetails,
                )
                .then((result) => {
                    this.$swal({
                        title: "Success",
                        text: "Seller bank details updated successfully!",
                        type: "success",
                    });
                    this.$refs["modal-account"].hide();
                })
                .catch((err) => {
                    this.$swal({
                        title: "Sorry",
                        text: "Could not update seller bank details",
                        type: "error",
                    });
                });
        },
        editPaytmDetails(mode) {
            if (mode == "paytm") {
                this.$refs["modal-paytm"].show();
            } else if (mode == "cashfree") {
                this.$refs["modal-cashfree"].show();
            } else if ((mode = "account")) {
                this.$refs["modal-account"].show();
            }
        },
        async submitPaytmDetails(mode) {
            if (mode == "paytm") {
                let paytmPayload = {
                    user: {
                        category: this.partnerAllData.category,
                    },
                    paytm: {
                        appId: this.paytmId,
                        secretKey: this.paytmKey,
                    },
                };

                let paytmPayloadFinal = {
                    id: this.partnerAllData._id,
                    data: paytmPayload,
                };

                await this.$store
                    .dispatch(
                        "tenant/setPaymentConfigAction",
                        paytmPayloadFinal,
                    )
                    .then((res) => {
                        this.$swal({
                            title: "Success",
                            text: "Paytm details updated successfully!",
                            type: "success",
                        });
                        this.$refs["modal-paytm"].hide();
                    })
                    .catch((err) => {
                        this.$swal({
                            title: "Sorry",
                            text: "Unable to update paytm details",
                            type: "error",
                        });
                    });
            } else if (mode == "cashfree") {
                let cashfreePayload = {
                    user: {
                        category: this.partnerAllData.category,
                    },
                    cashfree: {
                        appId: this.cashfreeId,
                        secretKey: this.cashfreeKey,
                    },
                };

                let cashfreePayloadFinal = {
                    id: this.partnerAllData._id,
                    data: cashfreePayload,
                };

                await this.$store
                    .dispatch(
                        "tenant/setPaymentConfigAction",
                        cashfreePayloadFinal,
                    )
                    .then((res) => {
                        this.$swal({
                            title: "Success",
                            text: "Cashfree details updated successfully!",
                            type: "success",
                        });
                        this.$refs["modal-cashfree"].hide();
                    })
                    .catch((err) => {
                        this.$swal({
                            title: "Sorry",
                            text: "Unable to update cashfree details",
                            type: "error",
                        });
                    });
            }

            await this.getPartnerPaymentConfigAction(this.partnerAllData._id);
            try {
                if (this.getPartnerPaymentConfig.paytm) {
                    this.paytmId = this.getPartnerPaymentConfig.paytm
                        ? this.getPartnerPaymentConfig.paytm.appId
                        : "";
                    this.paytmKey = this.getPartnerPaymentConfig.paytm
                        ? this.getPartnerPaymentConfig.paytm.secretKey
                        : "";
                }

                if (this.getPartnerPaymentConfig.cashfree) {
                    this.cashfreeId = this.getPartnerPaymentConfig.cashfree
                        ? this.getPartnerPaymentConfig.cashfree.appId
                        : "";
                    this.cashfreeKey = this.getPartnerPaymentConfig.cashfree
                        ? this.getPartnerPaymentConfig.cashfree.secretKey
                        : "";
                }
            } catch {}
        },
        async updateCodOrOnline() {
            let payloadSetConfig = {
                id: this.partnerAllData._id,
                data: {
                    paymentMethod: {
                        cod: this.codEnable,
                        online: this.onlineEnable,
                    },
                },
            };

            await this.$store
                .dispatch(
                    "partner/updatePartnerPaymentPreferencesAction",
                    payloadSetConfig,
                )
                .then(async (result) => {
                    this.$swal({
                        title: "Success",
                        text: "Payment Methods Updated!",
                        type: "success",
                    });

                    await this.getPartnerPaymentPreferencesAction(
                        this.partnerAllData._id,
                    );
                    try {
                        if (
                            this.getPartnerPaymentPreferencesGetter
                                .preferences &&
                            this.getPartnerPaymentPreferencesGetter.preferences
                                .paymentMethod
                        ) {
                            this.onlineEnable =
                                this.getPartnerPaymentPreferencesGetter.preferences.paymentMethod.online;
                            this.codEnable =
                                this.getPartnerPaymentPreferencesGetter.preferences.paymentMethod.cod;
                        }
                    } catch {}
                })
                .catch((err) => {
                    this.$swal({
                        title: "Sorry",
                        text: "Unable to update payment Methods",
                        type: "error",
                    });
                });
        },
        changePeriod(event) {
            this.getTransactionHistory();
        },
        getTransactionHistory() {
            this.loading = true;
            let payload = {
                days: this.selectedPeriod.value,
                user: this.partnerAllData._id,
                method: "OFFLINE",
            };
            this.$store
                .dispatch("subscription/PaymentTransactionList", payload)
                .then((data) => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        async initiatePayment() {
            if (
                this.selectedPaymentType.value &&
                this.selectedPaymentType.value == "CHEQUE" &&
                this.amountValue != "" &&
                this.paymentDate != ""
            ) {
                let payload = {
                    amount: {
                        value: this.amountValue,
                        currency: "INR",
                    },
                    user: {
                        _id: this.partnerAllData._id,
                        category: this.partnerAllData.category,
                        mobile: this.partnerAllData
                            ? this.partnerAllData.authentication.phone
                            : "",
                        email: this.partnerAllData
                            ? this.partnerAllData.authentication.email
                            : "",
                    },
                    concern: "WALLET",
                    paymentInfo: {
                        paymentDate: this.paymentDate,
                        method: this.selectedPaymentType.value,
                        info: {
                            bank: this.bankName,
                            accountNumber: this.accountNumber,
                            IFSC: this.ifscNo,
                            fullName: this.fullName,
                            chequeNumber: this.chequeNo,
                            issueDate: this.issueDate,
                            depositDate: this.depositeDate,
                            comments: this.comments,
                        },
                    },
                };
                await this.$store
                    .dispatch("subscription/createPaymentRequest", {
                        data: payload,
                        method: "OFFLINE",
                    })
                    .then((result) => {
                        if (result.status === 1) {
                            this.$swal({
                                title: "Success",
                                text: "Payment Success!",
                                type: "success",
                            });
                            this.getTransactionHistory();
                        }
                        this.isShowPaymentModel = false;
                        this.amountValue = "";
                        this.comments = "";
                        this.selectedPaymentType = "";
                        this.accountNumber = "";
                        this.paymentDate = "";
                        this.receiptNo = "";
                        this.issueDate = "";
                        this.depositeDate = "";
                        this.fullName = "";
                        this.chequeNo = "";
                        this.ifscNo = "";
                        this.bankName = "";
                    })
                    .catch((err) => {
                        this.$swal({
                            title: "Error",
                            text: "Unable to create payment",
                            type: "error",
                        });
                    });
            } else if (
                this.selectedPaymentType.value &&
                this.selectedPaymentType.value == "CASH" &&
                this.amountValue != "" &&
                this.paymentDate != ""
            ) {
                let payload = {
                    amount: {
                        value: this.amountValue,
                        currency: "INR",
                    },
                    user: {
                        _id: this.partnerAllData._id,
                        category: this.partnerAllData.category,
                        mobile: this.partnerAllData
                            ? this.partnerAllData.authentication.phone
                            : "",
                        email: this.partnerAllData
                            ? this.partnerAllData.authentication.email
                            : "",
                    },
                    concern: "WALLET",
                    paymentInfo: {
                        paymentDate: this.paymentDate,
                        method: this.selectedPaymentType.value,
                        info: {
                            bank: this.bankName,
                            accountNumber: this.accountNumber,
                            IFSC: this.ifscNo,
                            fullName: this.fullName,
                            chequeNumber: this.chequeNo,
                            issueDate: this.issueDate,
                            depositDate: this.depositeDate,
                            comments: this.comments,
                        },
                    },
                };
                await this.$store
                    .dispatch("subscription/createPaymentRequest", {
                        data: payload,
                        method: "OFFLINE",
                    })
                    .then((result) => {
                        if (result.status === 1) {
                            this.$swal({
                                title: "Success",
                                text: "Payment Success!",
                                type: "success",
                            });
                            this.getTransactionHistory();
                        }
                        this.isShowPaymentModel = false;
                        this.amountValue = "";
                        this.comments = "";
                        this.selectedPaymentType = "";
                        this.accountNumber = "";
                        this.paymentDate = "";
                        this.receiptNo = "";
                        this.issueDate = "";
                        this.depositeDate = "";
                        this.fullName = "";
                        this.chequeNo = "";
                        this.ifscNo = "";
                        this.bankName = "";
                    })
                    .catch((err) => {
                        this.$swal({
                            title: "Error",
                            text: "Unable to create payment",
                            type: "error",
                        });
                    });
            } else {
                this.$swal({
                    title: "Error",
                    text: "Please fill up required fields",
                    type: "error",
                });
            }
        },
        updatePaymentInfo(item) {
            const data = {
                partner: this.partnerAllData._id,
                UPIID: item,
            };
            this.updatePreference(data)
                .then((response) => {
                    this.$swal({
                        title: "Success",
                        text: "Payment Info Updated successfully!",
                        type: "success",
                    });
                    this.$refs["modal-center"].hide();
                    this.getPreferenceAction(this.partnerAllData._id);
                })
                .catch((error) => {
                    this.$swal({
                        title: "Error",
                        text: "Could not Update Payment Info",
                        type: "error",
                    });
                });
        },
        editPayment() {
            this.paymentInfo = this.paymentInfoData;
            this.$refs["modal-center"].show();
        },
        openMakePayment() {
            this.isShowPaymentModel = true;
        },
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
    },
    async mounted() {
        this.loading = true;
        if (this.partnerAllData == null) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        }
        await this.getTransactionHistory();
        // await this.getPreferenceAction(this.partnerAllData._id);
        await this.getPartnerPaymentPreferencesAction(this.partnerAllData._id);
        try {
            if (
                this.getPartnerPaymentPreferencesGetter.preferences &&
                this.getPartnerPaymentPreferencesGetter.preferences
                    .paymentMethod
            ) {
                this.onlineEnable =
                    this.getPartnerPaymentPreferencesGetter.preferences.paymentMethod.online;
                this.codEnable =
                    this.getPartnerPaymentPreferencesGetter.preferences.paymentMethod.cod;
            }
        } catch {}

        if (this.partnerAllData.category == "SELLER") {
            await this.getSellerProviderConfigAction(this.partnerAllData._id);
            try {
                if (this.getSellerProviderConfig.bank) {
                    this.sellerPayementDetails.accHolderName = this
                        .getSellerProviderConfig.bank.accountName
                        ? this.getSellerProviderConfig.bank.accountName
                        : "";
                    this.sellerPayementDetails.ifscCode = this
                        .getSellerProviderConfig.bank.ifscCode
                        ? this.getSellerProviderConfig.bank.ifscCode
                        : "";
                    this.sellerPayementDetails.bankName = this
                        .getSellerProviderConfig.bank.name
                        ? this.getSellerProviderConfig.bank.name
                        : "";
                    this.sellerPayementDetails.accNo = this
                        .getSellerProviderConfig.bank.accountNo
                        ? this.getSellerProviderConfig.bank.accountNo
                        : "";
                    this.sellerPayementDetails.email = this
                        .getSellerProviderConfig.bank.email
                        ? this.getSellerProviderConfig.bank.email
                        : "";
                    this.sellerPayementDetails.phone = this
                        .getSellerProviderConfig.bank.phone
                        ? this.getSellerProviderConfig.bank.phone
                        : "";
                }

                if (this.getSellerProviderConfig.cashfree) {
                    this.sellerPayementDetails.vendorModeOptionSelect = {
                        label: "Cashfree",
                        value: "CASHFREE",
                    };
                    this.sellerPayementDetails.vendorMode = "Cashfree";
                    this.sellerPayementDetails.venderId = this
                        .getSellerProviderConfig.cashfree.vendorId
                        ? this.getSellerProviderConfig.cashfree.vendorId
                        : "Not Available";
                }

                if (this.getSellerProviderConfig.paytm) {
                    this.sellerPayementDetails.vendorModeOptionSelect = {
                        label: "Paytm",
                        value: "PAYTM",
                    };
                    this.sellerPayementDetails.vendorMode = "Paytm";
                    this.sellerPayementDetails.venderId = this
                        .getSellerProviderConfig.paytm.vendorId
                        ? this.getSellerProviderConfig.paytm.vendorId
                        : "Not Available";
                }
            } catch {}
        } else {
            await this.getPartnerPaymentConfigAction(this.partnerAllData._id);
            try {
                if (this.getPartnerPaymentConfig.paytm) {
                    this.paytmId = this.getPartnerPaymentConfig.paytm
                        ? this.getPartnerPaymentConfig.paytm.appId
                        : "";
                    this.paytmKey = this.getPartnerPaymentConfig.paytm
                        ? this.getPartnerPaymentConfig.paytm.secretKey
                        : "";
                }

                if (this.getPartnerPaymentConfig.cashfree) {
                    this.cashfreeId = this.getPartnerPaymentConfig.cashfree
                        ? this.getPartnerPaymentConfig.cashfree.appId
                        : "";
                    this.cashfreeKey = this.getPartnerPaymentConfig.cashfree
                        ? this.getPartnerPaymentConfig.cashfree.secretKey
                        : "";
                }
            } catch {}
        }

        if (this.partnerAllData.category == "SELLER") {
            this.checkSellerOrOther = true;
        } else {
            this.checkSellerOrOther = false;
        }
        this.isLoading = false;
    },
};
</script>
<style scoped>
.switch-adjustment-class {
    margin-top: -7px;
    
}

p {
    font-size: 13px;
}
h4 {
    font-size: 20px;
    color: var(--secondary);
}

h5 {
    font-size: 16px;
    color: var(--secondary);
}
h6 {
    font-size: 15px;
    color: var(--secondary);
}

.ac-details-class-vendor {
    font-size: 13px;
    color: #000000;
}
.ac-details-class {
    font-size: 15px;
    color: #000000;
}
.vendor-class {
    margin-top: -5px;
}
.my-payment-info-class {
    font-size: 18px;
    color: var(--secondary);
}
.row + .row {
    margin-top: 0px;
}
/* .nipige-v-card-class {
  background: #ffffff;
  border: 1px solid #ececec;
  box-sizing: border-box;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);

  border-radius: 10px;
} */
.nipige-v-card-class-top {
    background: #ffffff;
}
.input-width-change {
    width: 98%;
}
.date-style {
    margin-top: 3px;
}
.nipige-v-card-class-top-allowed {
    margin-top: 35px;
    background: #ffffff;
    /* border: 1px solid #dee3ea; */
    box-sizing: border-box;
    width: 100%;
    /* border: 1px solid #ececec; */
    border-radius: 10px;
}
.online-pay-method-class {
    margin-top: 15px;
}

.allowed-payment-card {
    padding: 1.25rem 1.5rem 1rem;
}

.allowed-payment-title {
    margin-bottom: 1.5rem;
    text-align: left;
}

.allowed-payment-list {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
}

.allowed-payment-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.allowed-payment-label {
    min-width: 72px;
    margin-bottom: 0;
    text-align: left;
}

.allowed-payment-colon {
    width: 14px;
    margin-right: 0.9rem;
    font-size: 18px;
    color: var(--secondary);
    line-height: 1;
    text-align: center;
}

.allowed-payment-switch {
    margin: 0;
    padding: 0;
}

.allowed-payment-card ::v-deep .allowed-payment-switch.v-input {
    margin: 0 !important;
    padding: 0 !important;
    flex: 0 0 auto;
}

.allowed-payment-card ::v-deep .allowed-payment-switch .v-input__slot {
    margin: 0 !important;
}

.allowed-payment-card
    ::v-deep
    .allowed-payment-switch
    .v-input--selection-controls__input {
    margin-right: 0 !important;
}

.allowed-payment-card ::v-deep .allowed-payment-switch .v-messages {
    display: none !important;
}
</style>
<style>
.make-payment {
    height: 49px;
}
.btn.focus,
.btn:focus {
    outline: 0;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}
.validate-error {
    position: absolute;
    bottom: -20px;
    left: 10px;
}
.input-wrapper {
    position: relative;
}
.modal-header.header-nipige-class {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--secondary) !important;
    border-radius: 10px 10px 0px 0px;
}

.modal-header.header-nipige-class .modal-title {
    width: 100%;
    margin: 0 !important;
    text-align: center;
    color: white !important;
    font-weight: 600;
}

.modal-header.header-nipige-class .close {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
    color: white !important;
    opacity: 1;
}
@media (max-width: 576px) {
    .table-responsive-sm {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    table {
        min-width: 700px; 
        white-space: nowrap;
    }

    th,
    td {
        white-space: nowrap;
    }
}
.custom-select {
    height: 38px !important;
    line-height: 38px !important;
    background-position: right 10px center !important;
}

</style>
